import { createStore, setStateHelper } from "@neonumy/ant-design";
import { StoreApi, UseBoundStore } from "zustand";

const initialState = {
  paymentWaitingValue: 0,
  invoicedValue: 0,
  paymentsValue: 0,
  budgetNotInvoicedValue: 0,
  priorityTasksInfo: undefined,
};

interface DashboardStore {
  resetStore: () => void;
  invoicedValue: number;
  paymentWaitingValue: number;
  budgetNotInvoicedValue: number;
  paymentsValue: number;
  priorityTasksInfo: Record<string, any> | undefined;
  setPaymentWaitingValue: (paymentWaitingValue: number) => void;
  setInvoicedValue: (invoicedValue: number) => void;
  setPaymentsValue: (paymentsValue: number) => void;
  setBudgetNotInvoicedValue: (budgetNotInvoicedValue: number) => void;
  setPriorityTasksInfo: (priorityTasksInfo: Record<string, any>) => void;
}

const useDashboardStore: UseBoundStore<StoreApi<DashboardStore>> = createStore<DashboardStore>(
  (set: (fn: (draft: Record<string, any>) => void) => void) => ({
    ...initialState,
    resetStore: () => {
      set(() => ({
        ...initialState,
      }));
    },
    setPaymentWaitingValue: (paymentWaitingValue: number) => {
      setStateHelper("paymentWaitingValue", paymentWaitingValue, set);
    },
    setInvoicedValue: (invoicedValue: number) => {
      setStateHelper("invoicedValue", invoicedValue, set);
    },
    setPaymentsValue: (paymentsValue: number) => {
      setStateHelper("paymentsValue", paymentsValue, set);
    },
    setBudgetNotInvoicedValue: (budgetNotInvoicedValue: number) => {
      setStateHelper("budgetNotInvoicedValue", budgetNotInvoicedValue, set);
    },
    setPriorityTasksInfo: (priorityTasksInfo: Record<string, any>) => {
      setStateHelper("priorityTasksInfo", priorityTasksInfo, set);
    },
  }),
);

export default useDashboardStore;
